import React from "react";
import { Container, Wrapper, Image } from "./Navbar.Styles";

const Navbar = () => {
  return (
    <Container>
      <Wrapper>
        <Image src="assets/almalogo.png" />
      </Wrapper>
    </Container>
  );
};

export default Navbar;
